const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.TAGALYS_CAROUSEL,
      () => {
        this.setupCarousel()
      },
    )
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.7,
              spacing: 0,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.3,
              spacing: 0,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
